<template>
    <div>
        <h2>{{ title }}</h2>
        <section class="vcalender" id="projects">            
            <div class="project-item" v-bind:key="item.title" v-for="item in json">
                <b>{{item.title}}</b> - {{item.tools}}<br />
                <div class="coursework">
                    {{item.description}}
                </div>
                <div v-if="item.images">
                    Screens:
                    <div>
                        <a :href="getImg(img)" data-lightbox="roadtrip" v-bind:key="img" v-for="(img,index) in item.images">
                            <img :src="getImg(img)" v-bind:alt="index" height="105" />
                        </a>                        
                    </div>
                </div>                
            </div>
        </section>
    </div>
</template>

<script>
import bankMillennium_1 from "../assets/img/bankMillennium_1.png";
import bankMillennium_2 from "../assets/img/bankMillennium_2.png";
import med_1 from "../assets/img/med_1.png";
import med_2 from "../assets/img/med_2.png";
import cgps_1 from "../assets/img/cgps_1.png";
import cgps_2 from "../assets/img/cgps_2.png";
import cgps_3 from "../assets/img/cgps_3.png";
import sb_1 from "../assets/img/sb_1.png";
import sb_2 from "../assets/img/sb_2.png";
import sb_3 from "../assets/img/sb_3.png";
import sb_4 from "../assets/img/sb_4.png";
import myva_1 from "../assets/img/myva_1.png";
import myva_2 from "../assets/img/myva_2.png";
import myva_3 from "../assets/img/myva_3.png";
import myva_4 from "../assets/img/myva_4.png";
import myva_5 from "../assets/img/myva_5.png";
import myva_6 from "../assets/img/myva_6.png";
import myva_7 from "../assets/img/myva_7.png";
import myva_8 from "../assets/img/myva_8.png";
import myva_9 from "../assets/img/myva_9.png";
import myva_10 from "../assets/img/myva_10.png";
import sambade from "../assets/img/sambade.png";
import g4s_1 from "../assets/img/g4s_1.png";
import g4s_2 from "../assets/img/g4s_2.png";

export default {
  name: "Projects",
  props: {
    title: String,
    json: Array
  },
  methods: {
      getImg(name){
          if(name=="bankMillennium_1"){
              return bankMillennium_1;
          }
          if(name=="bankMillennium_2"){
              return bankMillennium_2;
          }
          if(name=="med_1"){
              return med_1;
          }
          if(name=="med_2"){
              return med_2;
          }
          if(name=="cgps_1"){
              return cgps_1;
          }
          if(name=="cgps_2"){
              return cgps_2;
          }
          if(name=="cgps_3"){
              return cgps_3;
          }
          if(name=="sb_1"){
              return sb_1;
          }
          if(name=="sb_2"){
              return sb_2;
          }
          if(name=="sb_3"){
              return sb_3;
          }
          if(name=="sb_4"){
              return sb_4;
          }
          if(name=="myva_1"){
              return myva_1;
          }
          if(name=="myva_2"){
              return myva_2;
          }
          if(name=="myva_3"){
              return myva_3;
          }
          if(name=="myva_4"){
              return myva_4;
          }
          if(name=="myva_5"){
              return myva_5;
          }
          if(name=="myva_6"){
              return myva_6;
          }
          if(name=="myva_7"){
              return myva_7;
          }
          if(name=="myva_8"){
              return myva_8;
          }
          if(name=="myva_9"){
              return myva_9;
          }
          if(name=="myva_10"){
              return myva_10;
          }
          if(name=="sambade"){
              return sambade;
          }
          if(name=="g4s_1"){
              return g4s_1;
          }
          if(name=="g4s_2"){
              return g4s_2;
          }
      }
  }  
};
</script>